import { IActionTaskType } from 'src/Modules/Company/Interfaces/IActionTaskType';
import { ISelectOption, ITrainingArticle } from '../Interfaces';
import { COMMON_API_URLS } from '../Tools/CommonApiUrls';
import HttpClient from '../Tools/HttpClient';
import baseApiPath from '../Tools/baseApiPath';
import { BaseService } from './Base.service';
import { IFranchiseOfficeSelectOption } from '../Interfaces/IFranchiseOfficeSelectOption';
import { IRegion } from 'src/Modules/Company/Interfaces/IRegion';
import { ISiteRegionAutoDetect } from '../Interfaces/ISiteRegionAutoDetect.interface';

class CommonService extends BaseService {
  getActionStatusList = () =>
    this.http.get<ISelectOption[]>(COMMON_API_URLS.ActionStatusList);
  getActionTaskTypeList = () =>
    this.http.get<IActionTaskType[]>(COMMON_API_URLS.ActionTaskTypeList);
  getActionTypeList = () =>
    this.http.get<ISelectOption[]>(COMMON_API_URLS.ActionTypeList);
  getDealStatusList = () =>
    this.http.get<ISelectOption[]>(COMMON_API_URLS.DealStatusList);
  getLeadTypeList = () =>
    this.http.get<ISelectOption[]>(COMMON_API_URLS.LeadTypeList);
  getServiceTypeList = () =>
    this.http.get<ISelectOption[]>(COMMON_API_URLS.ServiceTypeList);
  getSupportiveRegions = () =>
    this.http.get<ISelectOption[]>(COMMON_API_URLS.SupportiveRegions);
  getRegions = () =>
    this.http.get<IRegion[]>(COMMON_API_URLS.Regions);
  /** How KML territories map to regions, and whether detection is on per country (bug 5695). */
  getSiteRegionAutoDetect = () =>
    this.http.get<ISiteRegionAutoDetect>(COMMON_API_URLS.SiteRegionAutoDetect);
  getVendorTypes = () =>
    this.http.get<ISelectOption[]>(COMMON_API_URLS.VendorTypes);
  getIndustries = () =>
    this.http.get<ISelectOption[]>(COMMON_API_URLS.Industries);

  getClientStatus = () =>
    this.http.get<ISelectOption[]>(COMMON_API_URLS.ClientStatus);

  getUsers = (userName?: string, usersCount?: number) => {
    return this.http.get<ISelectOption[]>(
      COMMON_API_URLS.Users(userName, usersCount)
    );
  };
  getFranchiseOffices = () => {
    return this.http.get<IFranchiseOfficeSelectOption[]>(
      COMMON_API_URLS.FranchiseOffices
    );
  };

    getSlaStatus = () => {
    return this.http.get<ISelectOption[]>(
      COMMON_API_URLS.SLAStatusList
    );
  };

  getImperansCompanies = (searchText?: string, count?: number) => {
    return this.http.get<ISelectOption[]>(
      COMMON_API_URLS.ImperansCompanies(searchText, count)
    );
  };

  getCrmTrainingArticle = () => {
    return this.http.get<ITrainingArticle | null>(
      COMMON_API_URLS.CrmTrainingArticle
    );
  };
}

export default new CommonService();
